module.exports = __webpack_public_path__ + "static/media/dispenseTheCards_2.96970925.mp3";